import { combineReducers } from "redux";
import sectionReducer from "./sectionReducer";
import productsReducer from "./productsReducer";
import shopReducer from "./shopReducer";
import userReducer from "./userReducer";
import configurationReducer from "./configurationReducer";
import pendingOrderReducer from "./pendingOrderReducer";
import orderReducer from "./orderReducer";
import componentReducer from "./componentReducer";
import driverReducer from "./driverReducer";
import handledItemsReducer from "./itemReducer";
import offerReducer from "./offerReducer";

export default combineReducers({
  sectionReducer,
  productsReducer,
  shopReducer,
  userReducer,
  pendingOrderReducer,
  configurationReducer,
  componentReducer,
  orderReducer,
  driverReducer,
  offerReducer,
  handledItems: handledItemsReducer,
});
